module.exports = __webpack_public_path__ + "img/blue-people-icon.dab69742.svg";